/**
 * One height for the public Header and the in-app AppHeader, so moving between
 * the site and the app doesn't make the bar jump. Both headers are fixed, so
 * whatever sits under them pads by the same amount (NAV_OFFSET), and anything
 * sticky on a window-scrolled page sticks just below them (NAV_STICKY_TOP).
 *
 * Full class strings on purpose: Tailwind only generates classes it can find
 * written out in source.
 */
export const NAV_HEIGHT = 'h-16 sm:h-[72px]';
export const NAV_OFFSET = 'pt-16 sm:pt-[72px]';
export const NAV_STICKY_TOP = 'top-16 sm:top-[72px]';
